'use client';

import { useEffect } from 'react';

import { PopupModal } from 'react-calendly';
import type { Prefill, Utm } from 'react-calendly/typings/calendly';

type CalendlyModalProps = {
  url: string;
  open: boolean;
  onOpenChange: (next: boolean) => void;
  onEventScheduled?: (payload: unknown) => void;
  prefill?: Prefill;
  utm?: Utm;
};

export default function CalendlyModal({
  url,
  open,
  onOpenChange,
  onEventScheduled,
  prefill,
  utm,
}: CalendlyModalProps) {
  useEffect(() => {
    const handler = (event: MessageEvent) => {
      if (event?.data?.event === 'calendly.event_scheduled') {
        onEventScheduled?.(event.data?.payload);
        onOpenChange(false);
      }
    };

    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [onEventScheduled, onOpenChange]);

  return (
    <PopupModal
      open={open}
      prefill={prefill}
      rootElement={document.body}
      url={url}
      utm={utm}
      onModalClose={() => onOpenChange(false)}
    />
  );
}
